import type { StockItem } from '../api/types'
import { config } from '../config'
import { QrCode } from './QrCode'

/**
 * QR-mærkatet på en vare (docs/DECISIONS.md beslutning 069).
 *
 * <b>Varer har deres egen adresse (`/v/`), ikke enhedernes (`/e/`).</b> Mærkatet
 * kan scannes med mobilens eget kamera, og så åbner telefonen den URL, der står
 * i koden - peger den på `/e/`, lander man på "enheden findes ikke", selv om
 * varen er der. To slags ting, to stier.
 *
 * Koden står også med tal og bogstaver under QR-koden, så den kan tastes ind,
 * hvis mærkatet er blevet snavset i en varevogn.
 */

/** URL'en der ender i QR-koden på en vare. */
export function stockItemUrl(code: string) {
  const base = config.publicUrl || window.location.origin
  return `${base.replace(/\/$/, '')}/v/${code}`
}

/** Tegner QR-koden som SVG, så den er skarp uanset printerens opløsning. */
export function StockQr({ code, size = 128 }: { code: string; size?: number }) {
  return <QrCode value={stockItemUrl(code)} size={size} />
}

/**
 * Ét mærkat, som det ser ud på papir.
 *
 * Genbruger enhedsmærkatets stil (`device-label`): det er samme størrelse, samme
 * printark og samme afstand - to næsten ens sæt regler ville drive fra hinanden.
 */
export function StockLabel({ item }: { item: StockItem }) {
  return (
    <div className="device-label">
      <StockQr code={item.code} size={132} />

      <div className="device-label__text">
        <div className="device-label__name">{item.name}</div>
        {item.supplierNumber && <div className="device-label__line">Varenr. {item.supplierNumber}</div>}
        {item.supplier && <div className="device-label__line">{item.supplier}</div>}

        <div className="device-label__code">{item.code}</div>

        <div className="device-label__footer">theodor christiansen · Scan for vare</div>
      </div>
    </div>
  )
}
